export interface PatentDeepViewSignatureRequest {
    patent_id: string;
}

export interface PatentDeepViewSignatureResponse {
    date: string;
    expire: number;
    from: string;
    objectKey: string;
    shareId: string;
    signature: string;
    version: string;
}

export interface PatentDeepViewApi {
    getPatentDeepViewSignature: (data: PatentDeepViewSignatureRequest) => Promise<PatentDeepViewSignatureResponse>;
}

export const PatentDeepViewApi = Symbol('PatentDeepViewApi');
